/* AvemPiese Vitrina v5 — lista cu tipurile de piese („Vezi toate tipurile”) și fereastra de reparații
   (butonul „Ai nevoie de o reparație?” de lângă WhatsApp). Se încarcă după theme.js. */
(function () {
  'use strict';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var opener = null;

  function openSvc(btn) {
    var dl = document.getElementById('svcDlg');
    if (!dl) return;
    opener = btn || null;
    if (typeof dl.showModal === 'function') { if (!dl.open) dl.showModal(); }
    else dl.setAttribute('open', '');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }
  function closeSvc(dl) {
    if (!dl) return;
    if (typeof dl.close === 'function') dl.close(); else dl.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* „Vezi toate cele N tipuri” / „Arată mai puține” */
    var tg = t.closest('[data-ptoggle]');
    if (tg) {
      var box = tg.closest('[data-ptypes]');
      if (!box) return;
      var open = box.classList.toggle('open');
      tg.setAttribute('aria-expanded', String(open));
      if (!open && box.getBoundingClientRect().top < 0) box.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' });
      return;
    }

    /* fereastra de reparații */
    var act = t.closest('[data-act="svc-open"], [data-act="svc-close"]');
    if (act) {
      e.preventDefault();
      if (act.dataset.act === 'svc-open') openSvc(act); else closeSvc(act.closest('dialog'));
      return;
    }
    /* apăsare pe fundalul întunecat din jurul ferestrei */
    if (t.matches && t.matches('dialog.svcdlg')) closeSvc(t);
  });

  document.addEventListener('close', function (e) {
    var dl = e.target;
    if (!dl || !dl.matches || !dl.matches('dialog.svcdlg')) return;
    if (opener) { opener.setAttribute('aria-expanded', 'false'); if (opener.focus) opener.focus({ preventScroll: true }); }
  }, true);
})();
